import {
    FETCH_PDF_AVAILABILITY,
    UPLOAD_PDF_AVAILABILITY,
} from '../../actionTypes/shared/apiActionTypes';
import { apiActionCreator } from '../../actionCreators';
import config from '../../../configs/master';
import { PDF_AVAILABILITY_KEYS } from '../../../constants/shared/PdfGenerationConstants';

export const fetchPdfAvailability = client => async dispatch => {
    await apiActionCreator(dispatch, FETCH_PDF_AVAILABILITY, client.getApplicationConfig);
};

export const uploadPdfAvailability = (pdfKey, client) => async (dispatch, getState) => {
    const state = getState();
    const { selectors } = config.root;
    const currentPdfKey = PDF_AVAILABILITY_KEYS[pdfKey];
    const { pdfAvailability, pdfAvailability_bk: pdfAvailabilityBK } =
        selectors.getPdfAvailability(state);
    const updatedPdfAvailability = pdfAvailability.map(pdf =>
        pdf.item === currentPdfKey ? { item: pdf.item, isNew: false } : pdf,
    );

    const additionalApiParams = {
        apiParams: [updatedPdfAvailability, pdfAvailabilityBK],
        additionalResponseParams: updatedPdfAvailability,
    };
    await apiActionCreator(
        dispatch,
        UPLOAD_PDF_AVAILABILITY,
        client.uploadAppicationConfig,
        additionalApiParams,
    );
};
